var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"px-md-5 px-2 py-5"},[_c('v-col',{attrs:{"cols":"12"}},[_c('TableInfo',{attrs:{"title":_vm.title,"tableInfo":_vm.rahbariyat}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }